import React, { useState, useEffect } from 'react';
import { withStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import { connect } from 'react-redux';
import MembershipPremium from "../MembershipsCards/MembershipPremium";
import MembershipPremiumPlus from "../MembershipsCards/MembershipPremiumPlus";
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { makeStyles } from '@material-ui/core/styles';
import { Route } from 'react-router-dom';
import ContractDocument from '../PDF/ContractDocument'
import { PDFViewer } from '@react-pdf/renderer';

const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    
  },
  paper: {
    display: 'flex',
    flexDirection: 'Column',
    width: "100%",
    height: "auto",
    backgroundColor: 'white',
    '&:focus': {
      outline: 'none'
    }
  },
  close: {
    display: 'flex',
    justifyContent: 'flex-end',
    cursor: 'pointer'

  }
  
});

function ContractModal(props) {
  let { open, onClose } = props;

  useEffect(() => {
  }, []);

  const classes = useStyles()

  return (
    <Dialog
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
  
      disableEscapeKeyDown
      open={open}
      fullWidth={true}
      onClose={onClose}
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
     
        <PDFViewer>
            <ContractDocument />
        </PDFViewer>
        {/*  {modalPayments.typeMembership === "Premium" ? <MembershipPremium /> : <MembershipPremiumPlus /> } */}
        
      
    </Dialog>
  )

}

const mapDispatchToProps = dispatch => ({

})

const mapStateToProps = (state) => ({
  modalPayments: state.ModalReducer.openModalPayments
});


export default connect(mapStateToProps, mapDispatchToProps)(ContractModal);